<main id="main" class="main">
 
  <!-- Loading Overlay -->
  <!-- <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading...</p>
  </div> -->
 
  <section class="section dashboard">
     <div class="container">
      <div>
        <h3>Velocity Configuration</h3>
      </div>
      <div class="text-end">
        <!-- <h3>Velocity Configuration</h3> -->
        <button class="btn btn-primary" (click)="viewTMRule()">Velocity Rule</button>
      </div>
      <br>
       <div class="row">
         <div class="col-lg-12 col-xl-12 col-6">

           <div class="card">
             <div class="card-body">
       

               <!-- Default Tabs -->
               <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
           
                  <a class="nav-link" [class.active]="activeTab === 'Merchant'" (click)="switchTab('Merchant')">Merchant</a>

              </li>
                 <!-- <li class="nav-item" role="presentation">
           
                     <a class="nav-link" [class.active]="activeTab === 'Agent'" (click)="switchTab('Agent')">Agent</a>

                 </li> -->
                 <li class="nav-item" role="presentation">
             
                     <a class="nav-link" [class.active]="activeTab === 'Customer'" (click)="switchTab('Customer')">Customer</a>

                 </li>
               </ul>
             
               <div class="tab-content pt-2" id="myTabContent">
                 <!-- <div class="tab-pane fade show active" id="Agent" role="tabpanel" aria-labelledby="agent-tab"> -->
                  <div id="Agent" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'Agent'? 'block' : 'none'}">

                 
                    <div class="d-flex">
                      
                      <div class="col-lg-4">
                        <label for="min" class="form-label">Select Type:</label>
                       <ng-select #filStatus (change)="getVelocityDetailsByAgent($event)" placeholder="Select Type" >
                         <ng-option value="CUSTOM">CUSTOM</ng-option>
                         <ng-option value="DEFAULT_AGENT">DEFAULT</ng-option>
                         
                       </ng-select>
                     </div>
                     <div class="col-lg-4" >
                      <label for="min" class="form-label">Agent Mobile Number :</label>
                       <input type="text" class="form-control" [(ngModel)]="searchAgentMobileField" placeholder="Enter Agent Mobile Number" maxlength="10" [readOnly]="mobileAgentField" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                       
                     </div>
                     <div class="col-lg-1" style="margin-top: 30px;">
                    <button (click)="searchAgentMobile()"  class="btn btn-primary"><i class="fa fa-search"></i></button>
                     </div>

                    
                     <div class="col-lg-3" >
                      <label for="min" class="form-label">Currency :</label>
                       <input type="text"class="form-control" [placeholder]="defaultCurrencyData" [value]="defaultCurrencyData" disabled>
                     </div>

                    </div>
                    <div class="text-center">
                      <label for="min" class="form-label">Name : {{AgentName}}</label>
                       
                     </div>
                   

                   <div class="row mt-3">
                    <div class="col-lg-2">
                      <div class="card align-items-center">
                        <div class="card-body">
                          <!-- Vertical Pills Tabs -->
                          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <button class="nav-link" [class.active]="SubAnother === 'Send'" (click)="switchTabSubAnother('Send')" type="button"
                              role="tab">Send</button>
                            <!-- <button class="nav-link" [class.active]="SubAnother === 'Receive'" (click)="switchTabSubAnother('Receive')"
                              type="button" role="tab">Receive</button> -->
                            <button class="nav-link" [class.active]="SubAnother === 'Wallet'" (click)="switchTabSubAnother('Wallet')"
                              type="button" role="tab">Wallet</button>
                            <!-- <button class="nav-link" [class.active]="SubAnother === 'Withdrawl'" (click)="switchTabSubAnother('Withdrawl')"
                              type="button" role="tab">Withdraw</button> -->
                          </div>
                          <!-- End Vertical Pills Tabs -->
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-10">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="Send" [ngStyle]="{ 'display': SubAnother=== 'Send' ? 'block' : 'none' }">
                         
                          <form #velocitySend="ngForm" (ngSubmit)="saveAgentVelocity(velocitySend.value)">
                             <div class="row mb-3">
                               <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Ticket Size</label>
                               <div class="col-sm-10">
                                 <div class="row g-3">
                                   <div class="col-md-6">
                                     <label for="min" class="form-label">Minimum</label>
                                     <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                   </div>
                                   <div class="col-md-6">
                                     <label for="max" class="form-label">Maximum</label>
                                     <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                   </div>
                                 </div>
                               </div>
                             </div>
                             <div class="row mb-3">
                               <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Transaction
                                 Limit</label>
                               <div class="col-sm-9">
                                 <div class="row g-3">
                                   <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                        <label class="form-check-label">
                                         <label for="daily" class="form-label">Daily</label>
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>


                                    <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                        <label class="form-check-label">
                                         <label for="daily" class="form-label">Weekly</label>
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                        <label class="form-check-label">
                                         <label for="daily" class="form-label">Monthly</label>
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>
                                 </div>
                               </div>
                             </div>
                             <div class="row mb-3">
                                <label for="transactionCount" class="col-sm-3 col-form-label align-self-end">Transaction Count</label>
                                <div class="col-sm-9">
                                 
                                  <div class="row g-3">
                                    <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox"> -->
                                        <label class="form-check-label">
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox"> -->
                                        <label class="form-check-label">
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>
                                    <div class="col-md-4 d-flex align-items-end">
                                      <div class="form-check">
                                        <!-- <input class="form-check-input" type="checkbox"> -->
                                        <label class="form-check-label">
                                          <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          <!-- <span class="mr-auto">XX Left</span> -->
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                             
                             <div class="row mb-3">
                               
                               <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns</label>
                         
                               <div class="col-sm-9">
                                 <div class="row g-3">
                                   <div class="col-md-4 d-flex">
                                     <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                     <label class="form-check-label">
                                      <label for="daily" class="form-label">Time (in Seconds)</label>
                                       <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionSeconds" name="successiveTransactionSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                     </label>
                                   </div>
                                   <div class="col-md-4 d-flex">
                                     <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                     <label class="form-check-label">
                                      <label for="daily" class="form-label">Count</label>
                                       <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionCount"  name="successiveTransactionCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                     </label>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             <div class="row mb-3">
                               <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns (Same Amount)</label>
                               <div class="col-sm-9">
                                 <div class="row g-3">
                                   <div class="col-md-4 d-flex">
                                     <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                     <label class="form-check-label">
                                       <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountSeconds" name="successiveTransactionAmountSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                     </label>
                                   </div>
                                   <div class="col-md-4 d-flex">
                                    <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                    <label class="form-check-label">
                                      <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountCount" name="successiveTransactionAmountCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                 </div>
                               </div>
                             </div>
                             <div class="text-end">
                               <button type="submit"  class="btn btn-primary">Submit</button>
                               <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                             </div>
                          </form>
                        </div>
                        <div class="tab-pane fade show active" id="Receive" [ngStyle]="{ 'display': SubAnother=== 'Receive' ? 'block' : 'none' }">
                          <!-- Content for 'Receive' tab -->
                        </div>
                        <div class="tab-pane fade show active" id="Wallet" [ngStyle]="{ 'display': SubAnother=== 'Wallet' ? 'block' : 'none' }">
                       
                             <div class="row">
                                 
                              <form #velocitySend="ngForm" (ngSubmit)="saveAgentVelocity(velocitySend.value)">
                                 <div class="col-sm-10">
                                     <div class="row g-3">
                                      <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Balance Allowed</label>
                                         <div class="col-md-3">
                                       
                                              <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          </div>
                                     </div>
                                     <div class="row g-3">
                                      <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Amount / Add Money Request</label>
                                          <div class="col-md-3">
                                              <label for="min" class="form-label">Daily</label>
                                              <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.walletVelocityConfig.dailyLimit" name="dailyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          </div>
                                          <div class="col-md-3">
                                              <label for="max" class="form-label">Weekly</label>
                                              <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.weeklyLimit" name="weeklyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          </div>
                                          <div class="col-md-3">
                                              <label for="max" class="form-label">Monthly</label>
                                              <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.monthlyLimit" name="monthlyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                          </div>
                                     </div>
                                 </div>
                                 <br>
                                 <div class="text-end">
                                  <button type="submit" class="btn btn-primary">Submit</button>
                                  <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                              </div>

                                </form>
                             </div>
                         
                          </div>
                        <div class="tab-pane fade show active" id="Withdrawl" [ngStyle]="{ 'display': SubAnother=== 'Withdrawl' ? 'block' : 'none' }">
                       
                          <form #velocitySend="ngForm" (ngSubmit)="saveAgentVelocity(velocitySend.value)">
                             <div class="row">
                                 <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Withdrawal Amount / Transaction</label>
                                 <div class="col-sm-10">
                                     <div class="row g-3">
                                         <div class="col-md-6">
                                             <label for="min" class="form-label">Minimum</label>
                                             <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.withdrawVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                         <div class="col-md-6">
                                             <label for="max" class="form-label">Maximum</label>
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.withdrawVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                     </div>
                                 </div>
                             </div>
                             <div class="row mb-3">
                                 <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Limit</label>
                                 <div class="col-sm-9">
                                     <div class="row g-3">
                                         <div class="col-md-4 d-flex align-items-end">
                                             <div class="form-check">
                                                 <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                 <label class="form-check-label">
                                                     <label for="daily" class="form-label">Daily</label>
                                                     <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                     <!-- <span class="mr-auto">XX Left</span> -->
                                                 </label>
                                             </div>
                                         </div>
                                         <div class="col-md-4 d-flex align-items-end">
                                             <div class="form-check">
                                                 <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                 <label class="form-check-label">
                                                     <label for="daily" class="form-label">Weekly</label>
                                                     <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                     <!-- <span class="mr-auto">XX Left</span> -->
                                                 </label>
                                             </div>
                                         </div>
                                         <div class="col-md-4 d-flex align-items-end">
                                             <div class="form-check">
                                                 <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                 <label class="form-check-label">
                                                     <label for="daily" class="form-label">Monthly</label>
                                                     <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                     <!-- <span class="mr-auto">XX Left</span> -->
                                                 </label>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                           
                             <div class="row mb-3">
                              <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Count</label>
                              <div class="col-sm-9">
                                  <div class="row g-3">
                                      <div class="col-md-4 d-flex align-items-end">
                                          <div class="form-check">
                                              <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                              <label class="form-check-label">
                                                  <label for="daily" class="form-label">Daily</label>
                                                  <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                  <!-- <span class="mr-auto">XX Left</span> -->
                                              </label>
                                          </div>
                                      </div>
                                      <div class="col-md-4 d-flex align-items-end">
                                          <div class="form-check">
                                              <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                              <label class="form-check-label">
                                                  <label for="daily" class="form-label">Weekly</label>
                                                  <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                  <!-- <span class="mr-auto">XX Left</span> -->
                                              </label>
                                          </div>
                                      </div>
                                      <div class="col-md-4 d-flex align-items-end">
                                          <div class="form-check">
                                              <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                              <label class="form-check-label">
                                                  <label for="daily" class="form-label">Monthly</label>
                                                  <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                  <!-- <span class="mr-auto">XX Left</span> -->
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                             <div class="text-end">
                                 <button type="submit" class="btn btn-primary">Submit</button>
                                 <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                             </div>
                       
                            </form>
                        </div>
                      </div>
                    </div>
                  </div>
                 
                 </div>

               </div><!-- End Default Tabs -->

               <div class="tab-content pt-2" id="myTabContent">
                <!-- <div class="tab-pane fade show active" id="Agent" role="tabpanel" aria-labelledby="agent-tab"> -->
                 <div id="Agent" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'Merchant'? 'block' : 'none'}">

                
                   <div class="d-flex">
                     
                     <div class="col-lg-4">
                       <label for="min" class="form-label">Select Type:</label>
                      <ng-select #filSearchMID (change)="getVelocityDetailsByMerchant($event)" placeholder="Select Type" >
                        <ng-option value="CUSTOM">CUSTOM</ng-option>
                        <ng-option value="DEFAULT_MERCHANT">DEFAULT</ng-option>
                        
                      </ng-select>
                    </div>
                    <div class="col-lg-4" *ngIf="!mobileMerchantField">
                     <label for="min" class="form-label">Merchant :</label>
                      <!-- <input type="text" class="form-control" [(ngModel)]="searchMerchantMobileField" placeholder="Enter Merchant Mobile Number" maxlength="10" [readOnly]="mobileMerchantField" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"> -->
                      <ng-select #merchantDropDownList id="merchant" (change)="merchantDropdown()"  placeholder="Select Merchant" [inputAttrs]="{maxlength: '100'}"
                        [(ngModel)]="merchant" >
                          <ng-option *ngFor="let merchant of Resultdata" [value]="merchant">
                            {{merchant.fullName}} ({{merchant.userId}})
                          </ng-option>
                        </ng-select>
                      
                    </div>
                    <div class="col-lg-1" style="margin-top: 30px;" *ngIf="!mobileMerchantField">
                   <button (click)="searchMerchantMobile()"  class="btn btn-primary"><i class="fa fa-search"></i></button>
                    </div>

                   
                    <div class="col-lg-3" >
                     <label for="min" class="form-label">Currency :</label>
                      <input type="text"class="form-control" [placeholder]="defaultCurrencyData" [value]="defaultCurrencyData" disabled>
                    </div>

                   </div>
                   <div class="text-center" *ngIf="!mobileMerchantField">
                     <label for="min" class="form-label">Name : {{MerchantName}}</label>
                      
                    </div>
                  

                  <div class="row mt-3">
                   <div class="col-lg-2">
                     <div class="card align-items-center">
                       <div class="card-body">
                         <!-- Vertical Pills Tabs -->
                         <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                           <!-- <button class="nav-link" [class.active]="SubAnother === 'Send'" (click)="switchTabSubAnother('Send')" type="button"
                             role="tab">Send</button> -->
                           <button class="nav-link" [class.active]="SubAnother === 'Receive'" (click)="switchTabSubAnother('Receive')"
                             type="button" role="tab">Receive</button>
                           <button class="nav-link" [class.active]="SubAnother === 'Wallet'" (click)="switchTabSubAnother('Wallet')"
                             type="button" role="tab">Wallet</button>
                           <!-- <button class="nav-link" [class.active]="SubAnother === 'Withdrawl'" (click)="switchTabSubAnother('Withdrawl')"
                             type="button" role="tab">Withdraw</button> -->
                         </div>
                         <!-- End Vertical Pills Tabs -->
                       </div>
                     </div>
                   </div>
                   <div class="col-lg-10">
                     <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="Receive" [ngStyle]="{ 'display': SubAnother=== 'Receive' ? 'block' : 'none' }">
                         <form #velocityReceive="ngForm" (ngSubmit)="saveMerchantVelocity(velocityReceive.value)">
                            <div class="row mb-3">
                              <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Ticket Size</label>
                              <div class="col-sm-10">
                                <div class="row g-3">
                                  <div class="col-md-6">
                                    <label for="min" class="form-label">Minimum</label>
                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  </div>
                                  <div class="col-md-6">
                                    <label for="max" class="form-label">Maximum</label>
                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Transaction
                                Limit</label>
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Daily</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>


                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Weekly</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Monthly</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                               <label for="transactionCount" class="col-sm-3 col-form-label align-self-end">Transaction Count</label>
                               <div class="col-sm-9">
                                
                                 <div class="row g-3">
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.receiveVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                             </div>
                            
                            <!-- <div class="row mb-3">
                              
                              <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns</label>
                        
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex">
                                    <label class="form-check-label">
                                     <label for="daily" class="form-label">Time (in Seconds)</label>
                                      <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionSeconds" name="successiveTransactionSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                  <div class="col-md-4 d-flex">
                                    <label class="form-check-label">
                                     <label for="daily" class="form-label">Count</label>
                                      <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionCount"  name="successiveTransactionCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                            <!-- <div class="row mb-3">
                              <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns (Same Amount)</label>
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex">
                                    <label class="form-check-label">
                                      <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountSeconds" name="successiveTransactionAmountSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                  <div class="col-md-4 d-flex">
                                   <label class="form-check-label">
                                     <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountCount" name="successiveTransactionAmountCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                   </label>
                                 </div>
                                </div>
                              </div>
                            </div> -->
                            <div class="text-end">
                              <button type="submit"  class="btn btn-primary">Submit</button>
                              <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                            </div>
                         </form>
                       </div>
                       <div class="tab-pane fade show active" id="Receive" [ngStyle]="{ 'display': SubAnother=== 'Receive' ? 'block' : 'none' }">
                         <!-- Content for 'Receive' tab -->
                       </div>
                       <div class="tab-pane fade show active" id="Wallet" [ngStyle]="{ 'display': SubAnother=== 'Wallet' ? 'block' : 'none' }">
                      
                            <div class="row">
                                
                             <form #velocityReceive="ngForm" (ngSubmit)="saveMerchantVelocity(velocityReceive.value)">
                                <div class="col-sm-10">
                                    <div class="row g-3">
                                     <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Balance Allowed</label>
                                        <div class="col-md-3">
                                      
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                    </div>
                                    <!-- <div class="row g-3">
                                     <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Amount / Add Money Request</label>
                                         <div class="col-md-3">
                                             <label for="min" class="form-label">Daily</label>
                                             <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.walletVelocityConfig.dailyLimit" name="dailyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                         <div class="col-md-3">
                                             <label for="max" class="form-label">Weekly</label>
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.weeklyLimit" name="weeklyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                         <div class="col-md-3">
                                             <label for="max" class="form-label">Monthly</label>
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.monthlyLimit" name="monthlyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                    </div> -->
                                </div>
                                <br>
                                <div class="text-end">
                                 <button type="submit" class="btn btn-primary">Submit</button>
                                 <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                             </div>

                               </form>
                            </div>
                        
                         </div>
                       <div class="tab-pane fade show active" id="Withdrawl" [ngStyle]="{ 'display': SubAnother=== 'Withdrawl' ? 'block' : 'none' }">
                      
                         <form #velocitySend="ngForm" (ngSubmit)="saveAgentVelocity(velocitySend.value)">
                            <div class="row">
                                <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Withdrawal Amount / Transaction</label>
                                <div class="col-sm-10">
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <label for="min" class="form-label">Minimum</label>
                                            <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.withdrawVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                        </div>
                                        <div class="col-md-6">
                                            <label for="max" class="form-label">Maximum</label>
                                            <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.withdrawVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Limit</label>
                                <div class="col-sm-9">
                                    <div class="row g-3">
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Daily</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Weekly</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Monthly</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                            <div class="row mb-3">
                             <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Count</label>
                             <div class="col-sm-9">
                                 <div class="row g-3">
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Daily</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Weekly</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Monthly</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                            <div class="text-end">
                                <button type="submit" class="btn btn-primary">Submit</button>
                                <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                            </div>
                      
                           </form>
                       </div>
                     </div>
                   </div>
                 </div>
                
                </div>

              </div><!-- End Default Tabs -->

               <div class="tab-content pt-2" id="myTabContent">
                <!-- <div class="tab-pane fade show active" id="Agent" role="tabpanel" aria-labelledby="agent-tab"> -->
                 <div id="Customer" class="tab-pane fade p-4 active show" [ngStyle]="{ 'display': activeTab === 'Customer'? 'block' : 'none'}">

                
                   <div class="d-flex" style="margin-top: -8px;">
                     
                     <div class="col-lg-4">
                       <label for="min" class="form-label">Select Type:</label>
                      <ng-select #filResellerPartnerId (change)="getVelocityDetailsByCustomer($event)" placeholder="Select Type" >
                        <ng-option value="CUSTOM">CUSTOM</ng-option>
                        <ng-option value="DEFAULT_CUSTOMER">DEFAULT</ng-option>
                        
                      </ng-select>
                    </div>
             
                    <div class="col-lg-4" *ngIf="!mobileCustomerField">
                      <label for="min" class="form-label">Customer Mobile Number :</label>
                       <input type="text" class="form-control" [(ngModel)]="searchCustomerMobileField" maxlength="10" placeholder="Enter Customer Mobile Number" [readOnly]="mobileCustomerField" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                       
                     </div>
                     <div class="col-lg-1" style="margin-top: 30px;" *ngIf="!mobileCustomerField">
                    <button (click)="searchCustomerMobile()"  class="btn btn-primary"><i class="fa fa-search"></i></button>
                     </div>

                   
                    <div class="col-lg-3" >
                     <label for="min" class="form-label">Currency :</label>
                      <input type="text"class="form-control" [placeholder]="defaultCurrencyData" [value]="defaultCurrencyData" disabled>
                    </div>

                   </div>
                   <div class="text-center" *ngIf="!mobileCustomerField">
                     <label for="min" class="form-label">Name : {{customerName}}</label>
                      
                    </div>

                  <!-- Domestic and International Buttons (Customer Tab Only - Send Tab) -->
                  <div class="text-center mt-3" *ngIf="activeTab === 'Customer' && SubAnother === 'Send'">
                    <button type="button" class="btn transaction-type-btn me-2" 
                      [class.selected]="selectedTransactionType === 'Domestic'"
                      (click)="switchTransactionType('Domestic')">Domestic</button>
                    <button type="button" class="btn transaction-type-btn" 
                      [class.selected]="selectedTransactionType === 'International'"
                      (click)="switchTransactionType('International')">International</button>
                  </div>
                  

                  <div class="row mt-3">
                   <div class="col-lg-2">
                     <div class="card align-items-center">
                       <div class="card-body">
                         <!-- Vertical Pills Tabs -->
                         <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                           <button class="nav-link" [class.active]="SubAnother === 'Send'" (click)="switchTabSubAnother('Send')" type="button"
                             role="tab">Send</button>
                           <!-- <button class="nav-link" [class.active]="SubAnother === 'Receive'" (click)="switchTabSubAnother('Receive')"
                             type="button" role="tab">Receive</button> -->
                           <button class="nav-link" [class.active]="SubAnother === 'Wallet'" (click)="switchTabSubAnother('Wallet')"
                             type="button" role="tab">Wallet</button>
                           <!-- <button class="nav-link" [class.active]="SubAnother === 'Withdrawl'" (click)="switchTabSubAnother('Withdrawl')"
                             type="button" role="tab">Withdraw</button> -->
                         </div>
                         <!-- End Vertical Pills Tabs -->
                       </div>
                     </div>
                   </div>
                   <div class="col-lg-10">
                     <div class="tab-content" id="v-pills-tabContent">
                       <div class="tab-pane fade show active" id="Send" [ngStyle]="{ 'display': SubAnother=== 'Send' ? 'block' : 'none' }">
                        
                         <form #velocitySend="ngForm" (ngSubmit)="saveCustomerVelocity(velocitySend.value)">
                            <div class="row mb-3">
                              <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Ticket Size</label>
                              <div class="col-sm-10">
                                <div class="row g-3">
                                  <div class="col-md-6">
                                    <label for="min" class="form-label">Minimum</label>
                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  </div>
                                  <div class="col-md-6">
                                    <label for="max" class="form-label">Maximum</label>
                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Transaction
                                Limit</label>
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Daily</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>


                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Weekly</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"  style="margin-top: 23%;"> -->
                                       <label class="form-check-label">
                                        <label for="daily" class="form-label">Monthly</label>
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                               <label for="transactionCount" class="col-sm-3 col-form-label align-self-end">Transaction Count</label>
                               <div class="col-sm-9">
                                
                                 <div class="row g-3">
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                   <div class="col-md-4 d-flex align-items-end">
                                     <div class="form-check">
                                       <!-- <input class="form-check-input" type="checkbox"> -->
                                       <label class="form-check-label">
                                         <input type="text" class="form-control" [(ngModel)]="velocityConfig.sendVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         <!-- <span class="mr-auto">XX Left</span> -->
                                       </label>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                             </div>
                            
                            <div class="row mb-3">
                              
                              <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns</label>
                        
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex">
                                    <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                    <label class="form-check-label">
                                     <label for="daily" class="form-label">Time (in Seconds)</label>
                                      <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionSeconds" name="successiveTransactionSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                  <div class="col-md-4 d-flex">
                                    <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                    <label class="form-check-label">
                                     <label for="daily" class="form-label">Count</label>
                                      <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionCount"  name="successiveTransactionCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <label for="successivetxns" class="col-sm-3 col-form-label align-self-end">Successive Txns (Same Amount)</label>
                              <div class="col-sm-9">
                                <div class="row g-3">
                                  <div class="col-md-4 d-flex">
                                    <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                    <label class="form-check-label">
                                      <input type="text" class="form-control" id="weekly" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountSeconds" name="successiveTransactionAmountSeconds" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                  <div class="col-md-4 d-flex">
                                    <!-- <input class="form-check-input align-self-end me-2" type="checkbox"> -->
                                    <label class="form-check-label">
                                      <input type="text" class="form-control" id="daily" [(ngModel)]="velocityConfig.sendVelocityConfig.successiveTransactionAmountCount" name="successiveTransactionAmountCount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="text-end">
                              <button type="submit"  class="btn btn-primary">Submit</button>
                              <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                            </div>
                         </form>
                       </div>
                       <div class="tab-pane fade show active" id="Receive" [ngStyle]="{ 'display': SubAnother=== 'Receive' ? 'block' : 'none' }">
                         <!-- Content for 'Receive' tab -->
                       </div>
                       <div class="tab-pane fade show active" id="Wallet" [ngStyle]="{ 'display': SubAnother=== 'Wallet' ? 'block' : 'none' }">
                      
                            <div class="row">
                                
                             <form #velocitySend="ngForm" (ngSubmit)="saveCustomerVelocity(velocitySend.value)">
                                <div class="col-sm-10">
                                    <div class="row g-3">
                                     <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Balance Allowed</label>
                                        <div class="col-md-3">
                                      
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                    </div>
                                    <div class="row g-3">
                                     <label for="ticketSize" class="col-sm-3 col-form-label align-self-end">Maximum Amount / Add Money Request</label>
                                         <div class="col-md-3">
                                             <label for="min" class="form-label">Daily</label>
                                             <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.walletVelocityConfig.dailyLimit" name="dailyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                         <div class="col-md-3">
                                             <label for="max" class="form-label">Weekly</label>
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.weeklyLimit" name="weeklyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                         <div class="col-md-3">
                                             <label for="max" class="form-label">Monthly</label>
                                             <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.walletVelocityConfig.monthlyLimit" name="monthlyLimit" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                         </div>
                                    </div>
                                </div>
                                <br>
                                <div class="text-end">
                                 <button type="submit" class="btn btn-primary">Submit</button>
                                 <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                             </div>

                               </form>
                            </div>
                        
                         </div>
                       <div class="tab-pane fade show active" id="Withdrawl" [ngStyle]="{ 'display': SubAnother=== 'Withdrawl' ? 'block' : 'none' }">
                      
                         <form #velocitySend="ngForm" (ngSubmit)="saveCustomerVelocity(velocitySend.value)">
                            <div class="row">
                                <label for="ticketSize" class="col-sm-2 col-form-label align-self-end">Withdrawal Amount / Transaction</label>
                                <div class="col-sm-10">
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <label for="min" class="form-label">Minimum</label>
                                            <input type="text" class="form-control" id="min" [(ngModel)]="velocityConfig.withdrawVelocityConfig.minAmount" name="minAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                        </div>
                                        <div class="col-md-6">
                                            <label for="max" class="form-label">Maximum</label>
                                            <input type="text" class="form-control" id="max" [(ngModel)]="velocityConfig.withdrawVelocityConfig.maxAmount" name="maxAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Limit</label>
                                <div class="col-sm-9">
                                    <div class="row g-3">
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Daily</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyAmount" name="dailyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Weekly</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyAmount" name="weeklyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-end">
                                            <div class="form-check">
                                                <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                                <label class="form-check-label">
                                                    <label for="daily" class="form-label">Monthly</label>
                                                    <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyAmount" name="monthlyAmount" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                    <!-- <span class="mr-auto">XX Left</span> -->
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                            <div class="row mb-3">
                             <label for="transactionLimit" class="col-sm-3 col-form-label align-self-end">Withdrawal Count</label>
                             <div class="col-sm-9">
                                 <div class="row g-3">
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Daily</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.dailyFrequency" name="dailyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Weekly</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.weeklyFrequency" name="weeklyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                     <div class="col-md-4 d-flex align-items-end">
                                         <div class="form-check">
                                             <!-- <input class="form-check-input" type="checkbox" style="margin-top: 23%;"> -->
                                             <label class="form-check-label">
                                                 <label for="daily" class="form-label">Monthly</label>
                                                 <input type="text" class="form-control" [(ngModel)]="velocityConfig.withdrawVelocityConfig.monthlyFrequency" name="monthlyFrequency" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                                                 <!-- <span class="mr-auto">XX Left</span> -->
                                             </label>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                            <div class="text-end">
                                <button type="submit" class="btn btn-primary">Submit</button>
                                <button type="reset" id="resetButton" class="btn btn-secondary">Reset</button>
                            </div>
                      
                           </form>
                       </div>
                     </div>
                   </div>
                 </div>
                
                </div>

              </div><!-- End Default Tabs -->



             </div>
           </div>

         </div>

       </div>
     </div>
   </section>

</main>

<app-modal #modalTmRule [modalConfig]="modalConfigReport" >

 

  <pdf-viewer 
      src="/assets/pdf/compliance/tmRule.pdf"
      [rotation]="0"
      [original-size]="false"
      [show-all]="false"
      [fit-to-page]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="false"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      class="viewer">
</pdf-viewer>
</app-modal> 

